import React, { useState } from 'react';

export default function Ticket() {
  const [openIndex, setOpenIndex] = useState(null);


  const toggle = (idx) => {
    setOpenIndex(openIndex === idx ? null : idx);
  };

  return (
    <div style={
      {
        fontFamily: 'Poppins, sans-serif'
      }
    } className="min-h-screen bg-black text-white">
     <style>
  {`
    a {
      text-decoration: underline;

    }
  `}
</style>
      <main className="px-[20px] bg-[#440A06]">
        <div className="text-start relative">
          <div 
            style={{
              backgroundImage: "url('/Group (1).png')",
              backgroundRepeat:"repeat-y",
              backgroundSize: "contain"
            }} 
            className='w-full bg-cover flex flex-col items-center bg-black border-[3px] md:border-[7px] border-white rounded-[15px] lg:rounded-[44px]'
          >
            <img src='/curve left.png' alt='Planet 3' className='absolute left-[2px] md:left-[5px] top-[30px] md:top-[50px] w-[33px] md:w-[100px]' />
            <img src='/curve right.png' alt='Planet 2' className='absolute right-[2px] md:right-[5px] top-[30px] md:top-[50px] w-[33px] md:w-[100px]' />
            
            <img 
              src='/TICKETS.png' 
              alt='Bandland Logo' 
              className='mt-[30px] w-[15%] mb-8' 
            />
            <div className='flex mt-[60px] w-[100%] px-[30px] md:px-[120px] justify-between'> 
                 <div className ='md:w-[28%] w-[48%]'>
            <img className='' src="/RR.webp"></img>
            <div className="text-white text-[8px] md:text-[15px] flex mt-[28px] justify-between ">
                <div onClick={()=>{window.location.href = 'https://in.bookmyshow.com/events/bandland-2026/ET00466059'}} className=" bg-[#9F7D52] font-bold w-[46%] border-white border-2 rounded-[8px] py-[10px] text-center">
                  BOOK NOW 
                </div>
                 <button onClick={() => toggle(0)} className={` font-bold  w-[46%] ${openIndex == 0? "bg-white text-black border-[#9F7D52]": "bg-[#9F7D52] border-white"}  border-2 rounded-[8px] py-[10px] text-center cursor-pointer`}>
                INCLUSION {openIndex == 0? "-": "+"
                }
                </button>
           </div>
           </div>
              <div className ='md:w-[28%] w-[48%]'>
           <img className='' src="/AS.webp"></img>
           <div className="text-white text-[8px] md:text-[15px] font-bold flex mt-[28px] justify-between ">
                <div onClick={()=>{window.location.href = 'https://in.bookmyshow.com/events/bandland-2026/ET00466059'}} className=" bg-[#9F7D52] w-[46%] border-white border-2 rounded-[8px] py-[10px] text-center">
                  BOOK NOW 
                </div>
                 <button onClick={() => toggle(1)} className={` font-bold  w-[46%] ${openIndex == 1? "bg-white text-black border-[#9F7D52]": "bg-[#9F7D52] border-white"}  border-2 rounded-[8px] py-[10px] text-center cursor-pointer`}>
                INCLUSION {openIndex == 1? "-": "+"
                }
                </button>
           </div>
              </div>
        
            <div className ='md:w-[28%] hidden md:block w-[40%]'>
            <img className='' src="/tikcet1.webp"></img>
            <div className="text-white text-[8px] md:text-[15px] font-bold flex mt-[28px] justify-between ">
                <div onClick={()=>{window.location.href = 'https://in.bookmyshow.com/events/bandland-2026/ET00466059'}} className=" bg-[#9F7D52] w-[46%] border-white border-2 rounded-[8px] py-[10px] text-center">
                  BOOK NOW 
                </div>
                 <button onClick={() => toggle(2)} className={` font-bold  w-[46%] ${openIndex == 2? "bg-white text-black border-[#9F7D52]": "bg-[#9F7D52] border-white"}  border-2 rounded-[8px] py-[10px] text-center cursor-pointer`}>
                INCLUSION {openIndex == 2? "-": "+"
                }
                </button>
           </div>
           </div>
                         </div>
          
          
              {openIndex === 0 && (
              <div style={{
                boxShadow: "0 7px 0px 0px #B17839"
              }} className="mt-[60px]  bg-[#15B388] border-[1px] border-black  w-[calc(100%-60px)] md:w-[calc(100%-240px)]  h-[292px] rounded-[20px]  p-[8px]">
                <div className="bg-[#8D5B3D]  border-[1px] border-black  h-[276px] rounded-[14px]  p-[8px]">
                  <div className="bg-[#00664D] p-[15px] md:p-[30px] pt-[5px] md:pt-[10px]   border-[1px] border-black  h-[260px] rounded-[20px] " 
                  
                  >
<img src="/TI 1.png" className='w-[220px] md:w-[250px]'>
 
</img>
<div className='pl-[20px] pt-[14px] text-[11px] md:text-[16px] font-semibold'>
<ul style={{   
  listStyleType: "disc"
}}>
  <li>
 Dedicated zone with elevated deck to main stage 1


  </li>
  <li>
 Dedicated entry lanes to the festival

  </li>
  <li>
Access to Citizen (General Access) 

  </li>
  <li>

Dedicated FnB for purchase 


  </li>
  <li>
    Dedicated washrooms

  </li>
  <li>
    Preferred Parking near the venue - limited, first come first serve
  </li>
</ul>
</div>


                  </div>
                </div>
              </div>
              )}
              {openIndex === 1 && (
              <div style={{
                boxShadow: "0 7px 0px 0px #B17839"
              }} className="mt-[60px] bg-[#E8767C] border-[1px] border-black  w-[calc(100%-60px)] md:w-[calc(100%-240px)]    h-[292px] rounded-[20px]  p-[8px]">
                <div className="bg-[#F01E44]  border-[1px] border-black   h-[276px] rounded-[14px]  p-[8px]">
                  <div className="bg-[#502739] p-[15px] md:p-[30px] pt-[5px] md:pt-[10px]   border-[1px] border-black  h-[260px] rounded-[20px] " >
                    <img src="/TI 1.png" className='w-[220px] md:w-[250px]'>
 
</img>
<div className='pl-[20px] pt-[14px] text-[12px] md:text-[16px] font-semibold'>
<ul style={{   
  listStyleType: "disc"
}}>
  <li>
 Backstage AC lounge with dedicated entry

  </li>
  <li>
 Dedicated front of Stage area for both stages





  </li>
  <li>
F&B not included. Dedicated FnB for purchase


  </li>
  <li>

Dedicated Washrooms



  </li>
  <li>
   Dedicated Parking

  </li>

</ul>
</div>
                  </div>
                </div>
              </div>
              )}
               <div className ='md:w-[28%] mt-[40px] md:hidden w-[40%]'>
            <img className='' src="/tikcet1.webp"></img>
            <div className="text-white text-[8px] md:text-[15px] font-bold flex mt-[28px] justify-between ">
                <div onClick={()=>{window.location.href = 'https://in.bookmyshow.com/events/bandland-2026/ET00466059'}} className=" bg-[#9F7D52] w-[46%] border-white border-2 rounded-[8px] py-[10px] text-center">
                  BOOK NOW 
                </div>
                 <button onClick={() => toggle(2)} className={` font-bold  w-[46%] ${openIndex == 2? "bg-white border-[#9F7D52] text-black": "bg-[#9F7D52] border-white"}  border-2 rounded-[8px] py-[10px] text-center cursor-pointer`}>
                 INCLUSION {openIndex == 2? "-": "+"
                }
                </button>
           </div>
           </div>
                   {openIndex === 2 && (
              <div style={{
                boxShadow: "0 7px 0px 0px #B17839"
              }} className="mt-[60px] bg-[#EF5A11] border-[1px] border-black  w-[calc(100%-60px)] md:w-[calc(100%-240px)]    h-[292px] rounded-[20px]  p-[8px]">
                <div className="bg-[#EF5A11]  border-[1px] border-black h-[276px] rounded-[14px]  p-[8px]">
                  <div className="bg-[#134A64] p-[15px] md:p-[30px] pt-[5px] md:pt-[10px]  border-[1px] border-black  h-[260px] rounded-[20px] " >
                    <img src="/TI 1.png" className='w-[220px] md:w-[250px]'>
 
</img>
<div className='pl-[20px] pt-[14px] text-[12px] md:text-[16px] font-semibold'>
<ul style={{   
  listStyleType: "disc"
}}>
  <li>
    
 General Access to the festival on both days




  </li>
  <li>
General Access to festival bars and F&B

  </li>
 
</ul>
</div>
                  </div>
                </div>
              </div>
              )}
                   
            


            <img 
              src='/Screenshot 2025-10-08 132457.png' 
              alt='Event Details' 
              className='mt-16 w-[88%] mb-[15px] sm:mb-[0px]' 
            />
          </div>
        </div>
      </main>
    </div>
  );
}